import {
  Paper,
  useTheme,
  IconButton,
  Divider,
  Tooltip,
  Stack,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import EditOffIcon from "@mui/icons-material/EditOff";
import EditIcon from "@mui/icons-material/Edit";
import StraightenIcon from "@mui/icons-material/Straighten";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import SubtitlesOffOutlinedIcon from "@mui/icons-material/SubtitlesOffOutlined";
import SubtitlesOutlinedIcon from "@mui/icons-material/SubtitlesOutlined";
import { useReactFlow } from "reactflow";
import {
  TuneOutlined,
  LabelOffOutlined,
  LabelOutlined,
  VolumeUp,
  VolumeDown,
  VolumeOff,
} from "@mui/icons-material";

import { useState } from "react";

import ConfigLocalPopover from "../configLocalPopover";
import ConfiguracaoMapModal from "../configMapModal";
import { useMapa } from "../../../contexts/mapaContext";
const ToolBarMaps = ({
  checkChanges,
  proceedUpdateMode = () => {},
  setOpenAlertModal = () => {},
  setFullScreem,
  fullScreem = false,
  setEditMode,
  editMode = false,
  setLockMode,
  lockMode = false,
  setShowLabel,
  showLabel = true,
  setShowLabelEnlace,
  showLabelEnlace = true,
  setShowRuler,
  showRuler = false,
  children,
  tipo = 0,
  setEasyMapsConfig = () => {},
  easyMapsConfig,
  setRulerPoint,
  collapse = true,
}) => {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState(null);
  const { soundState, setSoundState } = useMapa();

  const styles = {
    content: {
      padding: "5px",
      position: "absolute",
      zIndex: 1,
      display: "flex",
      flexDirection: "column",
      ml: { xs: "3px", lg: "10px" },
      transition: "margin-left 0.3s ease",
      top: editMode ? { xs: "40px", lg: "10px" } : { xs: "3px", lg: "10px" },
      alignItems: "center",
      gap: 0.5,
      justifyContent: "center",
    },

    card: {
      borderRadius: "6px",
      border: "1px solid " + theme.palette.color.appBarBorder,
      padding: "5px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: 0.75,
      backgroundColor: theme.palette.background.default,
      justifyContent: "center",
      zIndex: 10,
    },
    paper: {
      display: "flex",
      flexDirection: "column",
      gap: "2px",
      justifyContent: "center",
      alignItems: "center",
    },
    switch: {
      width: "100%",
      ml: "0px",
      mr: "0px",
    },
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleChange = (event, path, name) => {
    setEasyMapsConfig((data) => {
      if (data?.[path]) {
        data[path][name] = event.target.checked;
      } else {
        data = {};
        data[path] = { [name]: event.target.checked };
      }
      return { ...data };
    });
  };

  return (
    <Stack sx={styles.content}>
      <Paper elevation={0} sx={styles.card}>
        {children}

        <IconButtonCustom
          title={fullScreem ? "Sair da Tela Cheia" : "Tela Cheia"}
          iconOn={FullscreenIcon}
          iconOff={FullscreenExitIcon}
          variable={fullScreem}
          onclick={setFullScreem}
        />
        <IconButtonCustom
          title={
            editMode ? "Desativar modo de edição" : "Ativar modo de edição"
          }
          iconOn={EditIcon}
          iconOff={EditOffIcon}
          variable={editMode}
          onclick={setEditMode}
        />

        <IconButtonCustom
          title={showLabel ? "Ocultar Detalhes" : "Mostrar detalhes"}
          iconOn={SubtitlesOutlinedIcon}
          iconOff={SubtitlesOffOutlinedIcon}
          variable={showLabel}
          onclick={setShowLabel}
        />
        {setShowRuler && (
          <IconButtonCustom
            title={showRuler ? "Desativar Régua" : "Ativar Régua"}
            iconOn={StraightenIcon}
            iconOff={StraightenIcon}
            variable={showRuler}
            onclick={() => {
              setShowRuler(!showRuler);
              setRulerPoint([]);
            }}
          />
        )}

        {tipo === 1 && (
          <IconButtonCustom
            title={""}
            iconOn={LabelOutlined}
            iconOff={LabelOffOutlined}
            variable={showLabelEnlace}
            onclick={setShowLabelEnlace}
          />
        )}
        <IconButtonCustom
          title={"Ajustes"}
          iconOn={TuneOutlined}
          iconOff={TuneOutlined}
          variable={Boolean(anchorEl)}
          sendEvent={true}
          onclick={handleClick}
        />
        <IconButtonCustom
          title={
            soundState ? "Desativar sons de alerta" : "Ativar sons de alerta"
          }
          iconOn={VolumeUp}
          iconOff={VolumeOff}
          variable={soundState}
          sendEvent={true}
          onclick={() => {
            setSoundState((prev) => !prev);
          }}
        />
      </Paper>

      {/* <ConfigLocalPopover
        position={fullScreem ? { top: 220, left: 70 } : { top: 280, left: 380 }}
        anchorEl={anchorEl}
        setAnchorEl={setAnchorEl}
        setEasyMapsConfig={setEasyMapsConfig}
        easyMapsConfig={easyMapsConfig}
      /> */}
      <ConfiguracaoMapModal open={Boolean(anchorEl)} setOpen={handleClose} />
    </Stack>
  );
};
const IconButtonCustom = ({
  title,
  iconOn: IconOn,
  iconOff: IconOff,
  variable,
  onclick = () => {},
  sendEvent = false,
}) => {
  let theme = useTheme();
  let styles = {
    // icon: {
    //   color: theme.palette.color.icons,
    // },
    button: {
      borderRadius: "5px",
      padding: "5px",
      backgroundColor: theme.palette.background.paperSelectedMaps,
      boxShadow: "0px 0px 5px  #00000015",
      "&:hover": { backgroundColor: theme.palette.background.hover },
    },
  };
  return (
    <Tooltip title={title} placement="right">
      <IconButton
        aria-label="custom-icon-button"
        sx={{
          ...styles.button,
          ...(variable
            ? {
                color: theme.palette.primary.main,
              }
            : {}),
        }}
        onClick={(event) => onclick(sendEvent ? event : !variable)}
      >
        <IconOn />
        {/* {!variable ? <IconOn /> : <IconOff sx={styles.icon} />} */}
      </IconButton>
    </Tooltip>
  );
};
const InputZoomTop = () => {
  const { zoomIn, zoomOut } = useReactFlow();
  const styles = {
    button: {
      borderRadius: "5px",
      padding: "5px",
    },
  };
  return (
    <Stack>
      <IconButtonCustom
        title={"Zoom In"}
        iconOn={AddIcon}
        iconOff={AddIcon}
        variable={false}
        onclick={() => zoomIn()}
      />
      <Divider sx={{ width: "80%", ml: "10%" }} />
      <IconButtonCustom
        title={"Zoom Out"}
        iconOn={RemoveIcon}
        iconOff={RemoveIcon}
        variable={false}
        onclick={() => zoomOut()}
      />
    </Stack>
  );
};
const InputZoomGeo = ({ zoom }) => {
  const styles = {
    button: {
      borderRadius: "5px",
      padding: "5px",
    },
  };
  return (
    <Stack>
      <IconButtonCustom
        title={"Zoom In"}
        iconOn={AddIcon}
        iconOff={AddIcon}
        variable={false}
        onclick={() => zoom(1)}
      />
      <Divider sx={{ width: "80%", ml: "10%" }} />
      <IconButtonCustom
        title={"Zoom Out"}
        iconOn={RemoveIcon}
        iconOff={RemoveIcon}
        variable={false}
        onclick={() => zoom(-1)}
      />
    </Stack>
  );
};
ToolBarMaps.InputZoomGeo = InputZoomGeo;
ToolBarMaps.InputZoomTop = InputZoomTop;
export default ToolBarMaps;
